<template>
  <div class="pr-md-24">
    <div class="d-flex justify-end mb-2">
      <v-btn
        tile
        color="primary"
        @click="$router.push({ name: 'shipmentprofile-index' })"
      >
        <v-icon left>
          arrow_back
        </v-icon>
        Back
      </v-btn>
    </div>
    <v-card elevation="0" outlined class="pr-md-24 pl-md-4 mb-10 pt-4">
      <v-form ref="form" @submit.prevent="create">
        <v-row>
          <v-col class="pr-md-24">
            <div class="text-left mb-6">
              <h4 class="back--text gotham-book">General Information</h4>
            </div>
          </v-col>
        </v-row>
        <v-row class="mb-2">
          <v-col cols="12" md="6" class="py-0">
            <v-text-field
              label="Name"
              :rules="nameRules"
              v-model="profile.name"
              outlined
              required
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row class="mb-2">
          <v-col cols="12" md="6" class="py-0">
            <v-autocomplete
              v-model="profile.method"
              :rules="methodRules"
              :items="methods"
              outlined
              label="Method"
            ></v-autocomplete>
          </v-col>
        </v-row>
        <v-row class="mb-2">
          <v-col cols="12" md="6" class="py-0">
            <v-autocomplete
              v-model="profile.countries"
              :items="countries"
              outlined
              multiple
              label="Countries"
              item-text="name"
              item-value="id"
            ></v-autocomplete>
          </v-col>
        </v-row>
        <div class="d-flex justify-start mb-5">
          <v-btn type="submit" color="accent" class="font-bold"
            >Create Shipment Profile</v-btn
          >
        </div>
      </v-form>
    </v-card>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState({
      profile: state => state.shipmentprofiles.profile,
      countries: state => state.countries.countries
    })
  },
  data() {
    return {
      nameRules: [
        v => !!v || "Name is required",
        v => (v && v.length >= 4) || "Name must be at least 4 characters",
        v =>
          (v && v.length <= 250) || "Name must be less than than 250 characters"
      ],
      methodRules: [v => !!v || "Method is required"],
      methods: [
        { text: "Weight Based", value: "weight_based" },
        { text: "Price Based", value: "price_based" },
        { text: "Fixed Price", value: "fixed_price" }
      ]
    };
  },
  mounted() {
    this.$store.dispatch("countries/LOAD_COUNTRIES", {
      from: 0,
      to: 0
    });
  },
  methods: {
    async create() {
      if (this.$refs.form.validate()) {
        this.$swal({
          title: "Creating shipment profile...",
          html: "this will only take a moment...",
          icon: "info",
          didOpen: () => {
            this.$swal.showLoading();
          }
        });
        await this.$store.dispatch(
          "shipmentprofiles/CREATE_SHIPMENT_PROFILE",
          this.profile
        );
        this.$swal({
          title: "Success",
          html: "Shipment Profile has been created",
          icon: "info"
        });
      }
    }
  }
};
</script>
